<style>
    div {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        grid-gap: 0 0;
        justify-items: center;
    }
    a {
        display: inline-block;
        text-align: center;
        margin: 0;
        color: rgb(237 242 247);
        text-decoration: none;
        transition: color 0.5s;
        transition: color 0.5s;
    }
    a:hover {
        text-decoration: underline;
        color: #fffc00;
    }
</style>

<div>
    <a href="/index">Works</a>
    <a href="/publications">Books</a>
    <a href="/blog">Essays</a>
    <a href="/about">About Rik</a>
    <a href="/support">$MONEY$</a>
</div>
